import { Component, Vue } from "vue-property-decorator";
import useContentFeed from "@/hooks/useContentFeed";

type HookType = ReturnType<typeof useContentFeed>;

@Component({
  name: "WithContentFeed",
  setup() {
    const {
      contentFeedSearch,
      contentFeedFollowingSearch,
      contentFeedDiscoverySearch,
      contentFeedDeletePost,
      contentFeedStatsGetCount,
    } = useContentFeed();

    return {
      contentFeedSearch,
      contentFeedFollowingSearch,
      contentFeedDiscoverySearch,
      contentFeedDeletePost,
      contentFeedStatsGetCount,
    };
  },
})
export default class WithContentFeed extends Vue {
  public contentFeedSearch!: HookType["contentFeedSearch"];
  public contentFeedFollowingSearch!: HookType["contentFeedFollowingSearch"];
  public contentFeedDiscoverySearch!: HookType["contentFeedDiscoverySearch"];
  public contentFeedDeletePost!: HookType["contentFeedDeletePost"];
  public contentFeedStatsGetCount!: HookType["contentFeedStatsGetCount"];
}
